import { Component, OnInit, Optional, Inject } from '@angular/core';
import { EditDialogsNoticesService } from './edit-dialogs-notices.service';
import { DialogsAlertComponent } from '../../../../../../../shared/components/dialogs/dialogs-alert/dialogs-alert.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import * as _ from 'lodash';

@Component({
  selector: 'app-edit-dialogs-notices',
  templateUrl: './edit-dialogs-notices.component.html',
  styleUrls: ['./edit-dialogs-notices.component.css']
})
export class EditDialogsNoticesComponent implements OnInit {

  /** Subscripción para el guardado de un parametro */
  $guardar!: Subscription;

  loading: boolean = true;
  defaultLabel: string = "";
  selectedItemsLabel: string = "";
  styleFormat = {width: '100%', height: '150%'};

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: any,
              public editDialogsNoticesService: EditDialogsNoticesService,
              @Optional() private dialogRef: MatDialogRef<EditDialogsNoticesService>,
              private translateService: TranslateService,
              private dialog: MatDialog) { this.editDialogsNoticesService.build(); }

  ngOnInit() {
    this.editDialogsNoticesService.init(this.data).subscribe(result => {
      this.loading = false;
    });
  }

  /**
  * @description
  * Guardar el Notices
  */
  guardar() {
    this.loading = true;
    this.$guardar = this.editDialogsNoticesService.guardar().subscribe(value => {
      console.log(value);
      // -2: El número del notice está ausente
      // -1: El número del notice ya existe
      // false: Error al guardar
      if (value === -1 || value === false || value === -2) {
        this.errorNotices('WARNINGS.error_nuevo');
      }
      this.loading = false;
    }, error => {
      console.log(error);
      this.errorNotices('WARNINGS.error_nuevo');
      this.loading = false;
    });
  }

  /**
  * @description
  * Cierra el dialog notices
  */
  aceptar() {
    this.dialogRef.close(true);
  }

  /**
  * @description
  * Deshabilita o habilita el botón aceptar
  */
  deshabilitar(){
    let notice = this.editDialogsNoticesService.notice;
    let original = this.editDialogsNoticesService.originalNotices;
    return this.editDialogsNoticesService.compare(notice, original);
  }

  /**
  * @description
  * Abre un cuadro de dialogo para informar de un error
  * @param error Texto a mostrar
  */
  public errorNotices(error: string) {
    const dialogRef = this.dialog.open(DialogsAlertComponent, {
      disableClose: true,
      hasBackdrop: true,
      data: { texto: this.translateService.instant(error) }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
    });
  }

  mostrarValor(valor: string) {
    const dialogRef = this.dialog.open(DialogsAlertComponent, {
      disableClose: true,
      hasBackdrop: true,
      data: { texto: valor }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
    });
  }

}
